_ = require('underscore')

module.exports = require('../abstract').extend
  template: require('./index.pug')

  mixins: [
    require('shared/mixins/vue/window_key_listener_mixin')
  ]

  computed:

    visible: ->
      _.any(@popupsOrder)

    popupsOrder: ->
      @.$store.state.popups.popupsOrder

    popups: ->
      @.$store.state.popups.popups || {}

  methods:

    componentNameForKey: (key) ->
      "popup-#{@dataForKey(key).name}"

    dataForKey: (key) ->
      @popups[key] || {}

    onKeyupEsc: ->
      @.$store.dispatch('popups/windowKeyupEsc')


  watch:

    visible: (value) ->
      if value == true
        document.getElementsByTagName('body')[0].setAttribute('class', 'comp-popups-container-visible')
      else
        document.getElementsByTagName('body')[0].setAttribute('class', '')





// WEBPACK FOOTER //
// ./assets/js/shared_frontend/components/popups_container/index.coffee